// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__Uca2m","regular":"Divider_regular__QGPzn","strong":"Divider_strong__zzCmQ"};